import { ObjectLiteralElement } from "typescript";
import { ProcedureModel } from "./procedure";
import { TrajectoryPoints } from "./TrajectoryPoints";

export interface Trajectory {
  uniqueid:number,
  name: string,
  trajectoryPoints: TrajectoryPoints[],
  procedureName: string,
  procedureId: string,
  procedureType: string,
  procedureRnav: string,
}

export class TrajectoryModel implements Trajectory {
uniqueid:number = 0;
name:string;
trajectoryPoints: TrajectoryPoints[] = [];
procedureName;
procedureId;
procedureType: string = "SID";
procedureRnav: string = "B_RNAV";
mapstatus: boolean = true;
isselected: boolean = false;
}
